export function flatArray<T>(arrays: T[]):any[] {
    return [].concat.apply([], arrays);
}

export function UniqueValues<T>(array: T[]): T[] {
    return array.filter((value, index, self) => self.indexOf(value) === index);
}export function flatternArray<T>(array: any[]): T[] {
    return array.reduce((acc, val) => Array.isArray(val) ? acc.concat(flatternArray(val)) : acc.concat(val), []);
}